
import {
  RETURN_JOURNEY_CARD_HEIGHT_DESKTOP,
  RETURN_JOURNEY_CARD_HEIGHT_MOBILE,
  SINGLE_JOURNEY_CARD_HEIGHT_DESKTOP,
  SINGLE_JOURNEY_CARD_HEIGHT_MOBILE,
} from "src/Modules/Flights/constants";

type GetJourneyCardHeightParams = {
  isLargeScreen: boolean;
  isReturn: boolean;
};

export function getJourneyCardHeight({
  isLargeScreen,
  isReturn,
}: GetJourneyCardHeightParams) {
  const JOURNEY_CARD_HEIGHT_MAP = {
    desktop: {
      return: RETURN_JOURNEY_CARD_HEIGHT_DESKTOP,
      single: SINGLE_JOURNEY_CARD_HEIGHT_DESKTOP,
    },
    mobile: {
      return: RETURN_JOURNEY_CARD_HEIGHT_MOBILE,
      single: SINGLE_JOURNEY_CARD_HEIGHT_MOBILE,
    },
  };

  const deviceType = isLargeScreen ? "desktop" : "mobile";
  const journeyType = isReturn ? "return" : "single";

  return JOURNEY_CARD_HEIGHT_MAP[deviceType][journeyType];
}